import PropTypes from 'prop-types';
import React from "react";

const SVG = ({
  style = {},
  width = "100%",
  height = "100%",
  className = "",
  viewBox = "0 0 13.5 17.5"
}) => (
  <svg
    width={width}
    style={style}
    height={height}
    viewBox={viewBox}
    xmlns="http://www.w3.org/2000/svg"
    className={`svg-icon ${className || ""}`}
    xmlnsXlink="http://www.w3.org/1999/xlink"
  >
    <defs>
        <linearGradient 
            id="a"
            x1="16.03"
            x2="16.03"
            y1="5.35"
            y2="30.87"
            gradientTransform="matrix(1 0 0 -1 -2.87 33.36)"
            gradientUnits="userSpaceOnUse">
                <stop className="hexButton-offset-one" offset="0" />
                <stop className="hexButton-offset-two" offset="1" />
        </linearGradient>
        <linearGradient
            id="b"
            x1="16.03" 
            x2="16.03" 
            y1="2.59" 
            y2="33.36" 
            gradientTransform="matrix(1 0 0 -1 0 34)" 
            gradientUnits="userSpaceOnUse">
                <stop className="hexBorder-offset-one" offset="0" />
                <stop className="hexBorder-offset-two" offset="1" />
        </linearGradient>
    </defs>
    <path
        fill="url(#a)"
        d="M1.03 22.61V8.16l12.39-6.97 11.87 6.97v14.45l-11.87 6.97-12.39-6.97z"/>
    <path 
        fill="url(#b)"
        d="M16.29 1.83l11.87 7v14.42l-11.87 7-12.39-7V8.8l12.39-7m0-1.19l-.52.29-12.37 7-.53.29v15.66l.53.3 12.38 7 .52.29.51-.3 11.87-7 .52-.3V8.2l-.52-.29L16.81.94l-.51-.3z"
        transform="translate(-2.87 -.64)" />
  </svg>
);

SVG.propTypes = {
  style: PropTypes.object,
  width: PropTypes.number,
  height: PropTypes.number,
  className: PropTypes.string,
  viewBox: PropTypes.string
};

export default SVG;
